module.exports = __webpack_public_path__ + "img/myCourse.888ef123.png";